import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { css } from "styled-components";

filterListStyles.filterText = {
    variant: "h3",
    css: css`
        font-size: 21px;
        font-weight: bold;
        letter-spacing: 1.75px;
        line-height: 25px;
        color: #33333a;
        text-transform: uppercase;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        width: 100%;
        padding-bottom: 27px;
        @media all and (max-width: 992px) and (min-width: 0px) {
            display: none;
        }
    `,
};

filterListStyles.clearAllLink = {
    css: css`
        padding: 10px 0 20px 0;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 17px;
        color: #006bc0;
    `,
};
filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        div[class^="TagStyle"] {
            position: relative;
            button[class^="ButtonWrapper"] {
                border: 0px !important;
                background: transparent !important;
                position: absolute;
                margin-top: 3px;
                min-height: 0px;
                > span {
                    color: #333333;
                    > svg {
                        height: 20px;
                        width: 20px;
                        stroke-width: 1;
                    }
                }
            }
        }
    `,
};
filterListStyles.filterTag = {
    css: css`
        padding: 0;
        font-size: 13px;
        letter-spacing: 1.08px;
        line-height: 30px;
        color: #33333a;
        margin: 0;
        background: #fff;
        span[class^="TypographyStyle"] {
            margin-left: 26px;
            font-size: 13px;
            @media all and (max-width: 992px) {
                font-size: 14px;
            }
        }
    `,
};
filterListStyles.clearAllLink = {
    css: css`
        padding-bottom: 20px;
        span {
            color: rgb(0, 107, 192);
        }
    `,
};
